export type RentalApplicationStepCompletion = Readonly<Record<string, boolean | undefined>>;

export function isRentalApplicationStepCompleted(
  step: string,
  currentStep: string,
  completion: RentalApplicationStepCompletion,
): boolean {
  return step === 'review' ? currentStep === 'review' : completion[step] === true;
}

export function countCompletedRentalApplicationSteps(
  visibleSteps: readonly string[],
  currentStep: string,
  completion: RentalApplicationStepCompletion,
): number {
  return visibleSteps.filter((step) =>
    isRentalApplicationStepCompleted(step, currentStep, completion),
  ).length;
}
